import React, { useEffect, useState } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";
import { AuthNavbar } from "components/Navbars/components";
import routes from "routes.js";
import axios from 'utils/api';

const Auth = () => {
  // const [settings, setSettings] = useState([]);

  useEffect(() => {
    let mounted = true;
    
    if (mounted) {
      // axios.get(`settings/getbyid?id=1`)
      //   .then(response => {
      //     if (response) {
      //       setSettings(response.data.settings);
      //     }
      //   });
    }
  }, []);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === '/auth') {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  return (
    <>
      <div className="main-content">
        <AuthNavbar/>
        <div className="header bg-gradient-info py-7 py-lg-8">
          <Container>
            <div className="header-body text-center mb-7">
              <Row className="justify-content-center">
                <Col lg="5" md="6">
                  <h1 className="text-white">Welcome to Merchant Web Portal</h1>
                  <p className="text-lead text-light" style={{fontWeight: 400}}>
                      NetQR Web Portal is designed for merchant management and transaction monitoring.
                  </p>
                </Col>
              </Row>
            </div>
          </Container>
          <div className="separator separator-bottom separator-skew zindex-100">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon
                // className="fill-default"
                style={{fill: "#0066FF"}}
                points="2560 0 2560 100 0 100"
              />
            </svg>
          </div>
        </div>
        <Container className="mt--8 pb-5">
          <Row className="justify-content-center">
            <Switch>
              {getRoutes(routes[1].routes)}
              <Redirect from="*" to="/errors/error-404" />
            </Switch>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default Auth;
